<template>
  <div class="min-h-screen bg-zinc-50">
    <template v-if="!loading">
      <Navbar />
      <router-view />
    </template>
  </div>

  <VueQueryDevtools />
</template>

<script setup>
import { ref, onBeforeMount, onMounted } from 'vue'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { useAuthStore } from '@/stores/auth'
import useAccountFeatureFlagsQuery from './composables/queries/useAccountFeatureFlagsQuery'
import Navbar from '@/containers/Navbar/Navbar.vue'
import initialisePaddle from '@/utils/initialisePaddle'

const loading = ref(true)

const authStore = useAuthStore()

useAccountFeatureFlagsQuery()

onBeforeMount(async () => {
  await authStore.mountAuthSession()

  if (authStore.session) {
    await authStore.loadAccountData()
  }

  loading.value = false
})

onMounted(() => {
  initialisePaddle()
})
</script>
